import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const AlignJustifyIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M3,18h18v-2H3V18z M3,11v2h18v-2H3z M3,6v2h18V6H3z' />
    </svg>
  )
}
